export default "__VITE_ASSET__B10RGGWo__"